import { render, staticRenderFns } from "./GPTAssistants.vue?vue&type=template&id=5b0124dd&scoped=true"
import script from "./GPTAssistants.vue?vue&type=script&lang=js"
export * from "./GPTAssistants.vue?vue&type=script&lang=js"
import style0 from "./GPTAssistants.vue?vue&type=style&index=0&id=5b0124dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0124dd",
  null
  
)

export default component.exports